// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"600550c5","453":"8761da50"}[chunkId] + ".chunk.js";
};